import * as React from 'react';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import UserProfile from '~/apps/shared/containers/settings/UserProfile';


export default function() {
  return (
    <CurrentOrgInjector
      component={UserProfile}
    />
  );
};
